import React from 'react';
import Admissions from '../components/Admissions';

const AdmissionsPage = () => {
  return (
    <main className="pt-20">
      <Admissions />
    </main>
  );
};

export default AdmissionsPage; 